
















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import dayjs from 'dayjs';
import { mask } from 'vue-the-mask';
import Assets from '@/constants/assets';
import ValidationService from '@/modules/core/services/validation.service';

import Icon, { IconEnum } from '@/modules/shared/components/icon.component.vue';
import Tooltip from '@/modules/shared/components/tooltip.component.vue';
import numberField from '@/modules/shared/directives/number-field.directive.ts';


export enum InputType {
  Text = 'text',
  Password = 'password',
  Number = 'number',
  Date = 'date',
}

@Component({
  directives: {
    mask,
    numberField,
  },
  components: {
    Icon,
    Tooltip,
  },
})
export default class Input extends Vue {
  @Prop({ default: '' }) private inputValue!: string;
  @Prop({ default: InputType.Text }) private type!: InputType;
  @Prop() private placeholder!: string;
  @Prop() private inputLabel!: string;
  @Prop({ default: false }) private readOnly!: boolean;
  @Prop({ default: '' }) private mask!: string;
  @Prop({ default: '' }) private inputError!: string;
  @Prop({ default: false }) private clearIcon!: boolean;
  @Prop({ default: 0 }) private tabIndex!: number;
  @Prop({ default: '' }) private inputInfo!: string;


  private content: any = '';
  private dateInputLenght!: number;
  private isFocused: boolean = false;
  private iconEnum = IconEnum;
  private validationService = ValidationService;
  private infoHover: boolean = false;

  @Watch('inputValue')
  private onInputValueChanged(newVal: string, oldVal: string) {
    if (newVal !== '') {
      this.hideError();
    }
    this.content = newVal;
    if (this.dateChangeIsValid) {
      if (this.dateInputLenght > 8) {
        this.content = dayjs(this.content).format('DD/MM/YYYY');
      } else {
        const temp = this.content.split('/');
        temp[2] = '20' + temp[2];
        this.content = dayjs(`${temp[2]}-${temp[1]}-${temp[0]}`).format('DD/MM/YY');
      }
    } else if (this.type === InputType.Number) {
      this.content = this.formatNumber();
    }
  }

  private created() {
    if (this.inputValue) {
      if (this.type === InputType.Number) {
        this.content = this.formatNumber();
      } else {
        this.content = this.inputValue;
      }
    }
    if (this.mask) {
      this.dateInputLenght = this.mask.length - 1;
    }
  }

  get hasFocus() {
    return this.isFocused && !this.readOnly;
  }

  get hasContent() {
    return this.content && this.content.length > 0;
  }

  get stateIcon() {
    let icon = '';
    if (this.hasContent && !this.hasError) {
      icon = this.iconEnum.Tick;
    } else if (this.hasError) {
      icon = this.iconEnum.Cross;
    }
    return icon;
  }

  get hasError() {
    return this.inputError.length > 0;
  }

  get showClearIcon() {
    let show = false;
    if ( this.hasContent && (this.clearIcon || this.hasError) ) {
      show = true;
    }
    return show;
  }

  get isNumberOrDate() {
    return (this.type === InputType.Number || this.type === InputType.Date);
  }

  get inputType() {
    let result = '';
    if (this.type === InputType.Date) {
      result = 'text';
    } else {
      result = this.type;
    }
    return result;
  }

  get dateChangeIsValid() {
    return (
      this.type === InputType.Date &&
      dayjs(this.content).isValid() &&
      this.content.length > this.dateInputLenght
    );
  }

  get isDateWithCorrectLenght() {
    return (
      this.type === InputType.Date &&
      this.content.length > this.dateInputLenght
    );
  }

  get hasInfo() {
    return this.inputInfo.length > 0;
  }

  get infoIcon() {
    let icon = this.iconEnum.InfoStroke;
    if (this.infoHover) {
      icon = this.iconEnum.InfoFill;
    }
    return icon;
  }

  private handleFocus() {
    this.isFocused = true;
    this.$emit('on-focus');
  }

  private handleBlur() {
    this.isFocused = false;
    this.$emit('blur');
  }

  private handleKeyup(e: any) {
    this.$emit('keyup', e);
    this.hideError();
  }

  private handleClick() {
    this.$emit('click');
  }

  private handleInput(e: any) {
    let inputContent = '';
    if (this.isDateWithCorrectLenght) {
      const dateSplitted = this.content.split('/');
      let year = Number(dateSplitted[2]);
      if (String(year).length === 2) {
        year = Number('20' + year);
      }
      const month = Number(dateSplitted[1]);
      const day = Number(dateSplitted[0]);
      const formatDate = dayjs(`${year}-${month}-${day}`);
      if (formatDate.isValid()) {
        inputContent = formatDate.toISOString();
      }
    } else {
      inputContent = this.content;
    }
    this.$emit('input', inputContent.trim());
  }

  private formatNumber() {
    const inputNumberValue = Number(this.inputValue);
    return inputNumberValue.toString();
  }

  private hideError() {
    this.$emit('hide-error');
  }

  private cleanInput() {
    this.content = '';
    this.hideError();
    (this.$refs.inputElement as HTMLElement).focus();
  }

  private setInfoHover(val: boolean) {
    this.infoHover = val;
  }

}
